module.exports = __webpack_public_path__ + "static/img/wuman.4ac57be1.png";